module.exports = __webpack_public_path__ + "static/media/pdf.d7157e8b.svg";